import React from 'react';
import Lottie from 'lottie-react';
import LoaderAnimation from './loader-animation.json';

/**
 * @desc: Page de rediction pour les routes en cours de chargement
 */
const LoaderPage = () => {
    return (
        <div className="bg-point-background bg-custom-background dark:bg-slate-900 h-screen w-screen">
            <div className="bg-gradient-background bg-cover dark:bg-slate-900 h-screen  flex items-center justify-center	flex-col">
                <Lottie
                    animationData={LoaderAnimation}
                    loop={true}
                    style={{ width: '200px', height: '200px' }}
                />
            </div>
        </div>
    );
};

export default LoaderPage;
